import React, { useCallback, useEffect, useState } from 'react'

import { authActions, useAuthStore } from '../modules/auth'
import HomePage from '../pages/home/HomePage'
import InstallerPage from '../pages/installer/InstallerPage'
import SupportPage from '../pages/support/SupportPage'

const Root: React.FC = () => {
  const [isLoading, setIsLoading] = useState(true)
  const { isVerifiedZoom } = useAuthStore()
  const path = window.location.pathname

  const loadInitConfig = useCallback(async () => {
    await authActions.getVerifiedZoomContext()
    setIsLoading(false)
  }, [])

  useEffect(() => {
    loadInitConfig()
  }, [])

  if (isLoading) {
    return (
      <div className="App">
        <p className="App-loader">Loading...</p>
      </div>
    )
  }

  //TODO: Router here?
  if (path === '/support') {
    return <SupportPage />
  }

  return (
    <div>
      {isLoading ? <div>Loading...</div> : isVerifiedZoom ? <HomePage /> : <InstallerPage />}
    </div>
  )
}

export default Root
